import React, { useContext } from 'react';

import Tarea from './Tarea';
import Xtarea from './Xtarea';
import proyectoContext from '../../context/proyectos/proyectoContext';
import xtareaContext from '../../context/extratareas/xtareaContext';

const ListadoTareas = () => {

    // extraer el state inicial
    const proyectosContext = useContext(proyectoContext);
    const { proyecto, eliminarProyecto } = proyectosContext;

    // obtener la funcion del context de xtarea
    const xtareasContext = useContext(xtareaContext);
    const {xtareasproyecto} = xtareasContext;

    // si no hay proy seleccionado
    if(!proyecto) return <h2>Selecciona un proyecto</h2>

    // Array destructuring para extraer el proy actual
    const [proyectoActual] = proyecto;

    const tareasProyecto = [
        {id: 1, nombre: 'Calculo de consumos', estado: true, link: 'consumos'},
        {id: 2, nombre: 'Calculo de paneles', estado: false, link: 'paneles'},
        {id: 3, nombre: 'Calculo de inversores', estado: true, link: 'inversores'},
        {id: 4, nombre: 'Calculo de baterias', estado: false, link: 'baterias'}
    ];

    // Elimina un proy
    const onClickEliminar = () => {
        eliminarProyecto(proyectoActual._id)
    }

    return (
        <>  
        <h2>Proyecto: {proyectoActual.nombre}</h2>
        <h3>Cálculos Iniciales</h3>
        <ul className="listado-tareas">
            {tareasProyecto.length === 0
                ? (<li className="tarea"><p>No hay Tareas</p></li>)
                : tareasProyecto.map(tarea => (
                    <Tarea
                        key={tarea.id}
                        tarea={tarea}
                    />
                ))
            }
        </ul>
        <h3>Tareas adicionales</h3>
        <ul className="listado-tareas">
            {xtareasproyecto.length === 0
                ? (<li className="tarea"><p>No hay Tareas Adicionales</p></li>)
                : xtareasproyecto.map(xtarea => (
                    <Xtarea 
                        key={xtarea._id}
                        xtarea={xtarea}
                    />
                ))
            }
        </ul>
        <button
            type="button"
            className="btn btn-warning"
            onClick={onClickEliminar}
        >Eliminar Proyecto</button>
        </>
    );
}
 
export default ListadoTareas;